var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehiclecount({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4971_30943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1479 38.6304L34.1243 20.9745L43.5782 20.9648L47.9405 27.3893L51.8935 29.3739L51.8741 38.6304H32.1479Z",
    fill: "#E6E9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3584 26.5304L43.5784 20.9648L34.1245 20.9745L33.5034 26.5304H47.3584Z",
    fill: "#4FC2E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6929 26.5297L44.164 19.8594L33.1364 19.8707L30.9141 39.7329H52.9758L53.0001 28.6923L48.6929 26.5297ZM50.7729 37.5251H33.3838L35.1113 22.077L42.9947 22.069L46.8668 27.7704L47.1886 28.246L47.7013 28.5031L50.7874 30.0527L50.7729 37.5251Z",
    fill: "#E6E9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1233 8.82031H2.20782C0.988283 8.82031 0 9.8086 0 11.0281V37.5265C0 38.746 0.988283 39.7343 2.20782 39.7343H33.1217C34.3413 39.7343 35.3312 38.746 35.3312 37.5265V11.028C35.3312 9.80849 34.3429 8.82031 33.1233 8.82031Z",
    fill: "#FC6E51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7479 22.0742H37.54V26.5307H39.7479V22.0742Z",
    fill: "#3BAFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80695 8.79492H6.59912V39.549H8.80695V8.79492Z",
    fill: "#E9573F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4578 8.79492H13.25V39.549H15.4578V8.79492Z",
    fill: "#E9573F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1087 8.79492H19.9009V39.549H22.1087V8.79492Z",
    fill: "#E9573F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7596 8.79492H26.5518V39.549H28.7596V8.79492Z",
    fill: "#E9573F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0597 44.2053C46.1086 44.2053 48.5803 41.7336 48.5803 38.6847C48.5803 35.6357 46.1086 33.1641 43.0597 33.1641C40.0107 33.1641 37.5391 35.6357 37.5391 38.6847C37.5391 41.7336 40.0107 44.2053 43.0597 44.2053Z",
    fill: "#434A54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0406 44.2053C14.0896 44.2053 16.5612 41.7336 16.5612 38.6847C16.5612 35.6357 14.0896 33.1641 11.0406 33.1641C7.99167 33.1641 5.52002 35.6357 5.52002 38.6847C5.52002 41.7336 7.99167 44.2053 11.0406 44.2053Z",
    fill: "#434A54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9546 38.6832C41.9546 39.293 42.4495 39.7879 43.0593 39.7879C43.669 39.7879 44.164 39.293 44.164 38.6832C44.164 38.0733 43.669 37.5801 43.0593 37.5801C42.4495 37.5801 41.9546 38.0734 41.9546 38.6832Z",
    fill: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.93604 38.6832C9.93604 39.293 10.431 39.7879 11.0408 39.7879C11.6506 39.7879 12.1439 39.293 12.1439 38.6832C12.1439 38.0733 11.6506 37.5801 11.0408 37.5801C10.431 37.5801 9.93604 38.0734 9.93604 38.6832Z",
    fill: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9953 30.9004H50.7891C50.1793 30.9004 49.686 31.3953 49.686 32.0049C49.686 32.6147 50.1794 33.108 50.7891 33.108H52.9904L52.9953 30.9004Z",
    fill: "#ED5564"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4971_30943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehiclecount);
export default __webpack_public_path__ + "static/media/vehiclecount.df8fea7d675bdd9cab8d10c45d2deb05.svg";
export { ForwardRef as ReactComponent };